// src/modules/care-gaps/pages/CareGapsPageContainer.jsx
import * as React from "react";
import { CareGapProvider } from "../../../context/CareGapContext/CareGapContext";
import { ObservationProvider } from "../../../context/ObservationContext/ObservationContext";
import { InfoPat2Provider } from "../../../context/InfoPat2Context/InfoPat2Context";
import { NoRecentVisitProvider } from "../../../context/PatientContext/NoRecentVisitContext/NoRecentVisitContext";
import { AdvancedMdProvider } from "../../../context/AdvancedMD/AdvancedMdContext";
import CareGapsPage from "./CareGapsPage";

export default function CareGapsPageContainer() {
  return (
    <CareGapProvider>
      <ObservationProvider>
        <InfoPat2Provider>
          <NoRecentVisitProvider enableSummary={false}>
            <AdvancedMdProvider>
              <CareGapsPage />
            </AdvancedMdProvider>
          </NoRecentVisitProvider>
        </InfoPat2Provider>
      </ObservationProvider>
    </CareGapProvider>
  );
}
